<template>
  <div>
    <b-navbar toggleable class="mobile-header pt-1 d-flex">
      <b-navbar-brand href="https://www.ip.eng.tohoku.ac.jp/" class="typesquare_tags">
        <img src="@/assets/img/title_logo_sp.svg" alt="東北大学工学研究科・工学部 創造工学センター" />
      </b-navbar-brand>
      <div class="text-center page-title">
        <h6 class="pt-1 font-weight-bold">予約状況 / Vacancies</h6>
      </div>
      <b-navbar-toggle target="navbar-toggle-collapse" class="navbar-menu-toggle">
        <template v-slot:default="{ expanded }">
          <img v-if="expanded" src="@/assets/img/icon_menu_close.svg" />
          <img v-else src="@/assets/img/icon_menu.svg" />
        </template>
      </b-navbar-toggle>
    </b-navbar>
    <b-collapse id="navbar-toggle-collapse" is-nav>
      <b-navbar toggleable class="mobile-nav d-block">
        <b-navbar-nav class="ml-auto">
          <b-nav-item href="https://www.ip.eng.tohoku.ac.jp/facility/machines.html" target="_blank">
            <MobileLink>設備機器リスト / Equipment and Devices</MobileLink>
          </b-nav-item>
          <router-link to="/form" v-slot="{ href }">
            <b-nav-item :href="href" target="_blank">
              <MobileLink>予約申請フォーム / Booking Form</MobileLink>
            </b-nav-item>
          </router-link>
          <router-link to="/schedule" v-slot="{ href }">
            <b-nav-item :href="href">
              <MobileLink>PC用ページを表示する / View the page for PC</MobileLink>
            </b-nav-item>
          </router-link>
        </b-navbar-nav>
      </b-navbar>
    </b-collapse>
    <div>
      <div class="pl-3 pt-2 pb-3">
        <b-navbar-brand href="#">
          <b-button class="mr-1 mr-sm-4" @click="setToday">today</b-button>
          <b-button-group class="mr-1 mr-sm-4">
            <b-button @click="setPrev" :disabled="isDisabled">
              <svg
                width="1em"
                height="1em"
                viewBox="0 0 16 16"
                class="bi bi-chevron-left"
                fill="currentColor"                
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"
                />
              </svg>
            </b-button>
            <b-button @click="setNext">
              <svg
                width="1em"
                height="1em"
                viewBox="0 0 16 16"
                class="bi bi-chevron-right"
                fill="currentColor"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"
                />
              </svg>
            </b-button>
          </b-button-group>
          <b-button-group class="mr-2">
            <b-button @click="setModeDaily">day</b-button>
            <b-button @click="setModeMonthly">month</b-button>
          </b-button-group>
          <b-button-group>
            <b-form-datepicker
              v-model="selected_date"
              button-only
              right
              :hide-header="true"
              :date-disabled-fn="dateDisabled"
              @context="setTimelineItems()"
              locale="en-US"
            ></b-form-datepicker>
          </b-button-group>
        </b-navbar-brand>
      </div>
    </div>
    <b-container class="main pt-3 mobile-container">
      <div class="head">
        <b-row>
          <b-col cols="auto" class="types mb-2" v-for="ec in eventCategories" :key="ec.name">
            <span>
              <span class="block" :style="{ color: ec.color }"></span>
              {{ ec.name }} / {{ ec.name_en }}
            </span>
          </b-col>
        </b-row>
      </div>
      <hr />
      <b-row class="py-2">
        <b-col cols="12">
          <div class="row justify-content-center">
            <label class="col-auto col-form-label">設備機器・部屋 / Device・Room</label>
            <div class="col-auto col-md-6">
              <b-form-select v-model="category" @change="handleCategoryChanged">
                <b-form-select-option value selected>指定なし / unselected</b-form-select-option>
                <b-form-select-option
                  v-for="c in categories"
                  :key="c.id"
                  :value="c.id"
                >{{ c.name }} / {{ c.name_en }}</b-form-select-option>
              </b-form-select>
            </div>
          </div>
        </b-col>
      </b-row>
      <b-row class="py-2">
        <b-col cols="12">
          <div class="text-danger mb-2" style="font-size: 13px;" v-html="closedMessage"></div>
          <span>{{ formedSelectedDate }}</span>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-table
            :bordered="true"
            show-empty
            empty-text="予約されている設備・機器はありません。 / There are no reserved facilities / equipment."
            :fields="timeline_fields"
            :items="timeline_items"
            :head-variant="'light'"
          >
            <template v-slot:cell(time)="data">
              <div v-show="isDaily">
                <div v-if="isSameDay(data.item.start, data.item.end)">
                  {{ data.item.start | formatDatetimeToTime }} -
                  {{ data.item.end | formatDatetimeToTime }}
                </div>
                <div v-else-if="isSameYear(data.item.start, data.item.end)">
                  {{ data.item.start | formatDatetimeToDate }}
                  {{ data.item.start | formatDatetimeToTime }}
                  - {{ data.item.end | formatDatetimeToDate }}
                  {{ data.item.end | formatDatetimeToTime }}
                </div>
                <div v-else>
                  {{ data.item.start | formatDatetimeToDateWithYear }}
                  {{ data.item.start | formatDatetimeToTime }}
                  - {{ data.item.end | formatDatetimeToDateWithYear }}
                  {{ data.item.end | formatDatetimeToTime }}
                </div>
              </div>
              <div v-show="isMonthly">
                <div v-if="isSameDay(data.item.start, data.item.end)">
                  {{ data.item.start | formatDatetimeToDate }}
                  {{ data.item.start | formatDatetimeToTime }} -
                  {{ data.item.end | formatDatetimeToTime }}
                </div>
                <div v-else-if="isSameYear(data.item.start, data.item.end)">
                  {{ data.item.start | formatDatetimeToDate }}
                  {{ data.item.start | formatDatetimeToTime }}
                  - {{ data.item.end | formatDatetimeToDate }}
                  {{ data.item.end | formatDatetimeToTime }}
                </div>
                <div v-else>
                  {{ data.item.start | formatDatetimeToDateWithYear }}
                  {{ data.item.start | formatDatetimeToTime }}
                  - {{ data.item.end | formatDatetimeToDateWithYear }}
                  {{ data.item.end | formatDatetimeToTime }}
                </div>
              </div>
            </template>
            <template v-slot:cell(content)="data">
              <div>
                <span :style="{ color: data.item.color }">●</span>
                {{
                data.item.resource_name + " / " + data.item.resource_name_en
                }}
              </div>
              <div v-if=" data.item.rent === ''">
                {{ data.item.title }}&nbsp;&nbsp;{{ data.item.rent }}
              </div>
              <div v-else>
                {{ data.item.title }}&nbsp;&nbsp;台数：{{ data.item.rent }}
              </div>
            </template>
          </b-table>
        </b-col>
      </b-row>
    </b-container>
    <!-- フッター -->
    <div class="footer-links">
      <div class="pt-2 pb-2 pl-2 pr-2">
        <b-link href="https://www.ip.eng.tohoku.ac.jp/facility/machines.html" target="_blank">
          <MobileLink>設備機器リスト / Equipment and Devices</MobileLink>
        </b-link>
      </div>
      <div class="pt-2 pb-2 pl-2 pr-2">
        <router-link to="/form" v-slot="{ href }">
          <b-link :href="href" target="_blank">
            <MobileLink>予約申請フォーム / Booking Form</MobileLink>
          </b-link>
        </router-link>
      </div>
      <div class="pt-2 pb-2 pl-2 pr-2">
        <router-link to="/schedule" v-slot="{ href }">
          <b-link :href="href">
            <MobileLink>PC用ページを表示する / View the page for PC</MobileLink>
          </b-link>
        </router-link>
      </div>
    </div>
    <div class="pb-1 pt-1 page-footer">
      <span>東北大学 工学研究科・工学部 創造工学センター</span>
      <br />
      <span>
        ©{{ getThisYear }} Innovation Plaza, School of Engineering, Tohoku
        University
      </span>
    </div>
    <div id="page_top" v-show="scY > 50" @click="toTop">
      <font-awesome-icon :icon="['fas', 'angle-up']" />
    </div>
  </div>
</template>

<script>
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import resourceTimelinePlugin from "@fullcalendar/resource-timeline";
import { INITIAL_EVENTS, createEventId } from "@/utils/event-utils";
import MobileLink from "@/components/MobileLink";

import moment from "moment";
import _ from "lodash";
import axios from "axios";

// import reservation from "@/../public/reserved.json";

export default {
  components: {
    MobileLink,
  },
  data: function () {
    return {
      resource: "",
      view_type: "",
      events: [],
      eventCategories: [],
      resources: [],
      categories: [],
      timeline_fields: [
        { key: "time", label: "予約時間 / Booking Time" },
        { key: "content", label: "予約内容 / Details" },
      ],
      timeline_items: [],
      selected_date: "",
      mode: "daily",
      holidays: [],
      closedDays: [],
      category: "",
      scTimer: 0,
      scY: 0,
    };
  },
  mounted() {
    axios.get("reserved.json").then(response => {
      this.mountData(response.data);
    });

    // TOPへ戻るボタンイベント
    window.addEventListener("scroll", this.handleScroll);

    this.selected_date = moment().format("YYYY-MM-DD");
    // 開発時のみ
    // this.selected_date = "2020-07-16"
  },
  computed: {
    isDisabled() {
        let currentDate = new Date();
        let year = currentDate.getFullYear();
        let month = currentDate.getMonth(); 
        const oneWeekAgo = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate() - 7);
        let date = new Date(this.selected_date)
        return date < oneWeekAgo;
      
    },
    isDaily() {
      return this.mode === "daily";
    },
    isMonthly() {
      return this.mode === "monthly";
    },
    formedSelectedDate() {
      if (this.isMonthly) {
        return moment(this.selected_date).format("YYYY/M");
      }
      return moment(this.selected_date).format("YYYY/M/D (ddd)");
    },
    closedMessage() {
      const closedDayInfos = this.getClosedDayInfo(this.selected_date);
      if (typeof closedDayInfos == "undefined") {
        return "";
      }
      let resons = closedDayInfos.map(closed => {
        if (this.mode == "monthly") {
          let startDate = moment(closed.start_date).format("YYYY/M/D");
          let endDate = moment(closed.end_date).format("YYYY/M/D");
          return closed
            ? `${closed.reason.ja}のため、${startDate}～${endDate} は施設を利用できません。<br>Due to ${closed.reason.en}, facilities are not available from ${startDate} to ${endDate}.`
            : "";
        } else if (this.mode == "daily") {
          return closed
            ? `${closed.reason.ja}のため、施設を利用できません。<br>Due to ${closed.reason.en}, facilities are not available.`
            : "";
        }
      })
      return resons.join('<br><p style="margin-bottom: 5px;"></p>');
    },
    getThisYear: function () {
      return moment().year();
    },
  },
  methods: {
    mountData(data) {
      this.resources = data.resources;
      this.events = this.getDisplayEvent(data.events);;
      this.holidays = data.holidays;
      this.closedDays = data.closed_days;
      this.eventCategories = data.event_categories;
      this.categories = data.categories;
      this.timeline_items = this.convertEvents(data.events);
    },
    getDisplayEvent(params) {
    let events = [];
    for (let event of params) {
      const startDate = new Date(event.start);
      const endDate = new Date(event.end);
      const now = new Date();

      // 現在の日付から1週間前の日付を計算
      const oneWeekAgo = new Date();
      oneWeekAgo.setDate(now.getDate() - 7);

      // startDateとendDateの年月日を取得
      const startYear = startDate.getFullYear();
      const startMonth = startDate.getMonth();
      const startDateDay = startDate.getDate();
      const endYear = endDate.getFullYear();
      const endMonth = endDate.getMonth();
      const endDateDay = endDate.getDate();

      // oneWeekAgoの年月日を取得
      const oneWeekAgoYear = oneWeekAgo.getFullYear();
      const oneWeekAgoMonth = oneWeekAgo.getMonth();
      const oneWeekAgoDay = oneWeekAgo.getDate();

      // 条件: startの日付が1週間前より大きいかどうか
      const isStartAfterOneWeekAgo = startYear > oneWeekAgoYear ||
        (startYear === oneWeekAgoYear && startMonth > oneWeekAgoMonth) ||
        (startYear === oneWeekAgoYear && startMonth === oneWeekAgoMonth && startDateDay > oneWeekAgoDay);

      // 条件: startが1週間前の日付より前または同じで、かつendが1週間前の日付より後
      const isStartBeforeOrEqualOneWeekAgo = startYear < oneWeekAgoYear ||
        (startYear === oneWeekAgoYear && startMonth < oneWeekAgoMonth) ||
        (startYear === oneWeekAgoYear && startMonth === oneWeekAgoMonth && startDateDay <= oneWeekAgoDay);
      const isEndAfterOneWeekAgo = endYear > oneWeekAgoYear ||
        (endYear === oneWeekAgoYear && endMonth > oneWeekAgoMonth) ||
        (endYear === oneWeekAgoYear && endMonth === oneWeekAgoMonth && endDateDay >= oneWeekAgoDay);

      if (isStartAfterOneWeekAgo || (isStartBeforeOrEqualOneWeekAgo && isEndAfterOneWeekAgo)) {
        events.push(event);
      }
    }
    return events;
  },
    convertEvents(events) {
      let e1 = this.filteredEvents(events);
      let e2 = this.convertResourceIdToName(e1);
      let r1 = this.filterTodayEvents(e2);
      return this.filterCategories(r1);
    },
    filteredEvents(events) {
      let filtered = [];
      events.forEach(e =>
        e.group.forEach(g => {
          if(g.rent === null){
            g.rent =  5;
          }else if(g.rent === 0){
            g.rent = "";
          }else if(g.rent !== 0 && g.rent !== null){
            g.rent =  g.rent;
          }
          filtered.push(g);
        })
      );
      return filtered;
    },
    convertResourceIdToName(events) {
      // 部屋と設備・機器をフラットな状態にする
      let flat_resources = [];
      this.resources.forEach(r => {
        flat_resources.push(r);
        if (r.children) {
          r.children.forEach(r2 => {
            flat_resources.push(r2);
          });
        }
      });

      let converted = [];
      events.forEach(e => {
        let re = flat_resources.filter(r => r.id == e.resourceId)[0];
        e.resource_name = re.name;
        e.resource_name_en = re.name_en;
        e.resource_category_id = re.category_id != null ? re.category_id : "";
        converted.push(e);
      });

      return converted;
    },
    // 日付で絞り込む
    filterTodayEvents(events) {
      if (this.isDaily) {
        return events
          .filter(e => {
            const selectedDate = moment(this.selected_date);
            const start = moment(e.start);
            const end = moment(e.end);
            return (
              selectedDate.isSameOrAfter(start, "day") &&
              selectedDate.isSameOrBefore(end, "day")
            );
          })
          .sort((a, b) => {
            if (a.start > b.start) {
              return 1;
            } else if (a.start < b.start) {
              return -1;
            } else {
              if (a.end > b.end) {
                return 1;
              } else if (a.end < b.end) {
                return -1;
              } else {
                return 0;
              }
            }
          });
      }
      if (this.isMonthly) {
        return events
          .filter(
            e =>
              moment(this.selected_date).format("YYYY-MM") ==
              moment(e.start).format("YYYY-MM")
          )
          .sort((a, b) => {
            if (a.start > b.start) {
              return 1;
            } else if (a.start < b.start) {
              return -1;
            } else {
              if (a.end > b.end) {
                return 1;
              } else if (a.end < b.end) {
                return -1;
              } else {
                return 0;
              }
            }
          });
      }
      return events;
    },
    // カテゴリーで絞り込む
    filterCategories(timeline) {
      if (!this.category) {
        return timeline;
      }

      let filtered = _.cloneDeep(timeline);

      if (this.category == 999999) {
        // 部屋の場合
        return filtered.filter(r => r.resource_category_id == "");
      }

      return filtered.filter(r => r.resource_category_id == this.category);
    },
    setTimelineItems() {
      this.timeline_items = this.convertEvents(this.events);
    },
    setModeDaily() {
      this.mode = "daily";
      this.setToday()
    },
    setModeMonthly() {
      this.mode = "monthly";
      let startDate = moment(this.selected_date).startOf("month");
      while (this.isHoliday(startDate)) {
        startDate = startDate.add(1, "days");
      }
      this.selected_date = startDate.format("YYYY-MM-DD");
      this.setTimelineItems();
    },
    setToday() {
      this.selected_date = moment().format("YYYY-MM-DD");
      this.setTimelineItems();
    },
    setPrev() {
      let date = moment(this.selected_date);
      if (this.isDaily) {
        // 一つ前の営業日まで戻す
        do {
          date = date.subtract(1, "days");
        } while (this.isHoliday(date));
      }
      if (this.isMonthly) {
        // 前月の月初めに移動し、営業日まで進める
        date = date.subtract(1, "months").startOf("month");
        while (this.isHoliday(date)) {
          date = date.add(1, "days");
        }
      }
      this.selected_date = date.format("YYYY-MM-DD");
      this.setTimelineItems();
    },
    setNext() {
      let date = moment(this.selected_date);
      if (this.isDaily) {
        // 一つ前の営業日まで進める
        do {
          date = date.add(1, "days");
        } while (this.isHoliday(date));
      }
      if (this.isMonthly) {
        // 翌月の月初めに移動し、営業日まで進める
        date = date.add(1, "months").startOf("month");
        while (this.isHoliday(date)) {
          date = date.add(1, "days");
        }
      }
      this.selected_date = date.format("YYYY-MM-DD");
      this.setTimelineItems();
    },
    dateDisabled(ymd, date) {
      // 現在の日付を取得
      let currentDate = new Date();
      const oneWeekAgo = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate() - 7);
      return date < oneWeekAgo || this.isHoliday(moment(date));
    },
    isHoliday(date) {
      const momentDate = moment(date);
      // 土日
      const weekday = momentDate.weekday();
      if (weekday === 0 || weekday === 6) {
        return true;
      }
      // 祝日
      if (this.getHolidayInfo(momentDate)) {
        return true;
      }
      return false;
    },
    getHolidayInfo(date) {
      const momentDate = moment(date);
      return this.holidays.find(holiday => {
        if (moment(holiday.date).isSame(momentDate, "day")) {
          return true;
        }
      });
    },
    getClosedDayInfo(date) {
      const selectedDate = moment(date);
      if (this.mode == "monthly") {
        // 月表示の場合
        return this.closedDays.filter(
          closedDay =>
            // 本日の月と同月の休館日が含まれていれば、true
            selectedDate.month() == moment(closedDay.start_date).month() ||
            selectedDate.month() == moment(closedDay.end_date).month()
        );
      } else if (this.mode == "daily") {
        // 日表示の場合
        return this.closedDays.filter(closedDay =>
          // 本日の日付が休館日の期間内に含まれていれば、true
          selectedDate.isBetween(
            moment(closedDay.start_date),
            moment(closedDay.end_date),
            "day",
            "[]"
          )
        );
      }
    },
    handleCategoryChanged: function () {
      this.timeline_items = this.convertEvents(this.events);
    },
    handleScroll: function () {
      if (this.scTimer) return;
      this.scTimer = setTimeout(() => {
        this.scY = window.scrollY;
        clearTimeout(this.scTimer);
        this.scTimer = 0;
      }, 100);
    },
    toTop: function () {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
    isSameDay(start, end) {
      return moment(start).isSame(moment(end), "day");
    },
    isSameYear(start, end) {
      return moment(start).isSame(moment(end), "year");
    },
  },
  filters: {
    formatDatetimeToDate(datetimeStr) {
      return moment(datetimeStr).format("M/D (ddd)");
    },
    formatDatetimeToDateWithYear(datetimeStr) {
      return moment(datetimeStr).format("Y/M/D (ddd)");
    },
    formatDatetimeToTime(datetimeStr) {
      return moment(datetimeStr).format("H:mm");
    },
  },
};
</script>

<style lang="scss" scoped>
.main {
  font-size: 14px;
}

.head {
  ul {
    list-style-type: none;
    padding: 0;
    li {
      margin: 0;
    }
  }
  .notes {
    margin-left: 30px;
  }
  .types {
    .block {
      &::after {
        content: "●";
        padding-right: 3px;
      }
    }
  }
}

.mobile-nav {
  border-bottom: 1px solid #e2e2e2;
  background: #93b4c5;
  padding: 0;
}

.nav-item {
  border-bottom: 1px solid #fff;
  padding: 5px 10px;

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background: #93b4c5;
  }
}

.footer-links {
  & div {
    background: #1f1f1f;
    color: #fff;
    text-decoration: none;
    font-size: 13px;

    &:hover {
      background: #afafaf;
      color: #101010;
      div {
        background: #afafaf;
        color: #101010;
      }
    }
    &:focus {
      background: #afafaf;
      color: #101010;
      div {
        background: #afafaf;
        color: #101010;
      }
    }

    &:hover > a {
      background: #afafaf;
      color: #1f1f1f;
      text-decoration: none;
    }
    &:focus > a {
      background: #afafaf;
      color: #1f1f1f;
      text-decoration: none;
    }
  }
}

.navbar-menu-toggle {
  color: #fff;
  border: none;
  padding: 0;
  margin: 0;

  & img {
    width: 75%;
  }

  &:focus {
    outline: none;
  }
}

.mobile-container {
  min-height: 810px;

  @media screen and (min-width: 550px) and (max-width: 1000px) {
    min-height: 810px;
  }

  @media screen and (max-width: 550px) {
    min-height: 680px;
  }
}

.mobile-header {
  height: 60px;
  background: #fff;
  padding-right: 0px;
  border-bottom: 1px solid #cecece;

  & .typesquare_tags {
    margin: 0;
    & img {
      box-sizing: border-box;
      display: block;
      height: 40px;
    }
  }
}

.page-title {
  @media screen and (max-width: 450px) {
    display: none;
  }
}

// ページTOPへ戻るボタン
#page_top {
  width: 50px;
  height: 50px;
  position: fixed;
  right: 20px;
  bottom: 20px;
  background: #000000d4;
  border-radius: 50%;

  & svg {
    position: relative;
    display: block;
    width: 40px;
    height: 40px;
    text-decoration: none;
    color: #fff;
    margin-left: 5px;
    margin-top: 4px;
    cursor: pointer;
  }
}

.page-footer {
  width: 100%;
  color: #fff;
  background-color: #1f1f1f;
  font-size: 11px;
  text-align: center;
}
</style>
